import { analyzeSiteLevel as analyzeSiteLevelReq } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { ExecutionProfile } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/types';
import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useCallback } from 'react';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
import { AnalysisState, usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yDebug } from '../../hooks/use-a11y-debug';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
export const useAnalyzeSiteLevel = () => {
  const httpClient = useHttpClient();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const panelState = usePanelStateAtom();
  const {
    withErrorHandler
  } = useErrorHandler();
  const a11yDebug = useA11yDebug();
  const {
    experiments
  } = useExperiments();
  const analyzeSiteLevel = useCallback(async () => {
    panelState.setGroupData(SITE_LEVEL_PAGE_ID, {
      analysisState: AnalysisState.Analyzing
    });
    try {
      if (!experiments.enabled('specs.a11y.A11yWizardRmVersion')) {
        await a11yWizardAdapter.triggerEditorSave();
      }
      const response = await withErrorHandler(async () => httpClient.request(analyzeSiteLevelReq({
        options: {
          executionProfile: ExecutionProfile.EXECUTION_PROFILE_A11Y
        }
      })), {
        errorCodesMap: {}
      });
      a11yDebug.addAnalyzeResponse == null || a11yDebug.addAnalyzeResponse(response);
      const {
        job
      } = response.data;
      assertNotOptional(job, 'job');
      return job;
    } catch (error) {
      panelState.setGroupData(SITE_LEVEL_PAGE_ID, {
        analysisState: AnalysisState.AnalyzeFailed
      });
      throw error;
    }
  }, [panelState, a11yWizardAdapter, a11yDebug, httpClient, withErrorHandler, experiments]);
  return {
    analyzeSiteLevel
  };
};
//# sourceMappingURL=use-analyze-site-level.js.map